import { appData } from '@/mocks/homeData';

export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 rounded-3xl bg-gradient-to-br from-primary-500 to-accent-500 p-8 md:p-12 lg:p-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              {appData.title}
            </h2>
            <p className="text-background-200 font-heading text-lg mb-4">{appData.subtitle}</p>
            <p className="text-sm md:text-base text-background-100 leading-relaxed mb-6">
              {appData.desc}
            </p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20screen%20mockup%20with%20warm%20golden%20abstract%20art%2C%20clean%20minimalist%20UI%20style%2C%20soft%20amber%20gradients%2C%20elegant%20dark%20mode%20interface%2C%20video%20streaming%20app%20design%2C%20premium%20aesthetic%2C%20smooth%20transitions&width=448&height=796&seq=app-mockup-01&orientation=portrait"
                alt="向日葵视频移动端界面展示"
                title="向日葵视频移动端"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}